const zh = {
  Language: '切换语言',
  Chinese: '中文',
  English: '英文',
  welcome: '欢迎您加入',
  title: '区块链和多媒体数据科学(BMDS)研讨会',
  sponsored: '由纯白矩阵和阿尔伯塔大学计算机系多媒体研究生项目赞助',
  signUp: '报名',
  titleDate: '中国时间，4月27日-30日',
  date: '日期',
  Date1: '2021年4月27日-30日',
  Date2: '中国时间',
  duration: '时长',
  Duration1: '4天',
  Duration2: '每天2小时',
  event: '内容',
  Event1: '区块链',
  Event2: '多媒体数据科学',
  speaker: '发言人',
  Speaker1: '来自产业与学术界的',
  Speaker2: '学者与专家',
  ourSpeackers: '参会讲者',
  Conference: '研讨会日程',
  day1: '第一天,4月27日',
  day2: '第二天,4月28日',
  day3: '第三天,4月29日',
  day4: '第四天,4月30日',
  defaultSelect: '英文',
  blockchainTitle: '区块链',
  blockchainContent1:
    '区块链（Blockchain）是由密码学串接并保护内容的数据记录方式（又称区块）。每一个区块包含了前一个区块的加密散列、相应时间戳记以及交易资料（通常用默克尔树（Merkle tree）算法计算的散列值表示），这样的设计使得区块内容具有难以篡改的特性。用区块链技术所串接的分布式账本能让两方有效记录交易，且可永久查验此交易。',
  blockchainContent2:
    '以太坊在区块链基础上搭建了以太坊虚拟机（EVM），使图灵完备的程序可以在EVM上运行。纯白矩阵提供了ChainIDE让更多的开发者可以更方便地在区块链上编程，让更多的应用可以在区块链上落地。',
  multimediaTitle: '多媒体数据科学',
  multimediaContent1:
    '多媒体数据科学（Multimedia Data Science）是一门利用数据学习知识的学科，其目标是通过从数据中提取出有价值的部分来生产数据产品。它结合了诸多领域中的理论和技术，它涵盖的领域包括应用数学、统计、机器学习、数据可视化、数据仓库等等范围。数据科学技术可以帮助我们如何正确的处理数据并协助我们在生物学、社会科学、人类学等领域进行研究调研，让我们通过数据更好地认识这个世界。MRC旨在将多媒体数据科学的研究与教育传递到世界的每一个角落。',
  WhiteMatrix:
    '"每节课后都会有一个考勤打卡和作业测试，满勤可以获得纯白矩阵与MRC研究中心联合颁发的证书或NFT"',
  EdmontionTime: '加拿大时间',
  ChinaTime: '中国时间',
  FreeTime: '5分钟',
  Opening: '开始',
  Rest: '休息',
  Webpage: '网页',
  ConferenceContent1_1: '1. 阿尔伯塔大学理学院院长',
  ConferenceContent1_2: '2. 吴啸，纯白矩阵CEO',
  ConferenceContent1_3: '主持人：IreneCheng',
  ConferenceContent1_4: '开幕致辞',
  ConferenceContent2_1: '浅析区块链',
  ConferenceContent2_2: '张舒艺，纯白矩阵CTO',
  ConferenceContent3_1: '浅析数据科学',
  ConferenceContent3_2: '主持人：Irene Cheng',
  ConferenceContent3_3: 'Marchin Mizianty博士，AltaML公司数据科学副总裁',
  ConferenceContent4_1: '区块链主题演讲',
  ConferenceContent4_2: '吴啸，纯白矩阵CEO',
  ConferenceContent5_1: '区块链赋能隐私计算',
  ConferenceContent5_2: '王泽华，UBC博士',
  ConferenceContent6_1: 'AI：计算机视觉与机器学习',
  ConferenceContent6_2: '主持人：孙昕尧',
  ConferenceContent6_3: 'Anup Basu教授(阿尔伯塔大学)',
  ConferenceContent7_1: '数据科学主题演讲',
  ConferenceContent7_2: '主持人：Irene Cheng',
  ConferenceContent7_3: 'Brunce Matichuk博士，Health Gauge 联合创始人，CTO',
  ConferenceContent8_1: '区块链和多媒体数据科学应用|',
  ConferenceContent8_2: '蔡玮，香港中文大学（深圳）教授',
  ConferenceContent9_1: '区块链和多媒体数据科学||',
  ConferenceContent9_2: '主持人：Irene Cheng',
  ConferenceContent9_3: '孙昕尧，纯白矩阵研发科学家，阿尔伯塔大学博士候选人',
  ConferenceContent10: '寻找"产业机会"(加拿大、中国和国际)圆桌会议',
  ConferenceContent10_1: '1. Neha Raj，加拿大多伦多花旗银行副总裁',
  ConferenceContent10_2: '2. Jun Yu，蚂蚁集团投资总监兼A&T资本管理合伙人',
  ConferenceContent10_3: '3. Aaron Liu，BestBuy市场研发部的首席工程师',
  ConferenceContent10_4: '4. Carlos，Nanopay的COO',
  ConferenceContent11_1:
    '多媒体数据科学专业学生项目决赛(演示) 问答每次最多15分钟',
  ConferenceContent11_2: '主持人：Irene Cheng',
  speackerDesription: 'Matina Kalcounis Rueppell博士是阿尔伯塔大学理学院院长。',
  speackerDesription1:
    'Carlos Garcia拥有巴西圣保罗FGV商学院的工商管理学本科，目前在Nanopay Corporation（2019年度区块链公司）担任支付部门首席运营官，主要负责公司的全球市场战略布局，加强与各地区伙伴的合作，确保公司在支付系统生态中的产品和功能均符合相关法律法规。他还负责公司内部核心管理，包括合作伙伴集成和生产系统，支付运营，客户成功和欺诈/反洗钱团队。在加入Nanopay之前，他曾担任Deloitte的高级经理，负责支付现代化团队。在加入Deloitte之前，他在Western Union Company工作了12年，担任美洲和欧洲的技术交付和运营副总裁，负责开发全渠道市场，该部门占业务收入的80％。',
  speackerDesription2:
    'Neha Raj目前担任花旗银行副总裁，负责银行，资本市场和咨询部门。她曾在汇丰银行和美国银行从事产品开发和商业化运作，并在Nanopay Corporation（2019年度区块链公司）担任交付经理。Neha是一名工程师和商科毕业生， 在过去的十年中，她曾担任软件开发人员，业务分析师，客户交付经理，商业化经理和产品经理，拥有Scrum Master认证。',
  speackerDesription3:
    'Bruce Matichuk教授本硕博都在阿尔伯特大学，重点研究领域为人工智能，曾是多家AI公司的创始人，包括Celcorp，Poynt，Salu Design Group和Aidant Intelligent Technology。他研发的产品已用于众多世界500强公司，包括Liberty Mutual Insurance Company，Holiday Inn，American Airlines等。 他的研究方向主要有基于神经网络的生物特征分析，图像识别，行为分析和智能代理。 他在AI领域拥有很多专利和论文。Bruce教授目前是Health Gauge公司的联创人和CTO，也同时也是一家专注于AI / ML产品的上市公司AIML Innovation Inc.（CSNX：AIML）的CTO。',
  speackerDesription4:
    '创始人吴啸，毕业于加拿大阿尔伯塔大学计算机科学(AlphaGo 诞生地)硕士专业， 师从 Dale Schuurmans 院士(曾担任 Google Brain 谷歌大脑项目负责人)本科、硕士跳级完成学业，并且拿到全额奖学金，期间论文获得 Cocos(全球最大开源引擎)和 CSDN 首页精品推荐。2019 年入选南京市、南京市江北新区高层次创业领军人才。 2020中国区块链开发大赛一等奖。',
  speackerDesription5:
    'Marcin Mizianty博士目前在AltaML公司数据科学部门担任副总裁，拥有加拿大阿尔伯塔大学软件工程和智能系统博士学位，以及波兰克拉科夫AGH科技大学应用计算科学理学硕士学位。他发表了30余篇行业论文，并在软件工程，机器学习，大数据和预测分析方面拥有超过十年的实践学术和行业经验。 Marcin热衷于建立和发展高性能的数据科学研究团队，以及管理和协调相关大数据产品。 目前，他正在AltaML领导数据科学部门项目，并担任部分副总裁。Marcin还参与了Edmonton的数据科学社区，并共同发起了Edmonton数据科学沙龙，并在北阿尔伯特理工学院教授数据科学课。',
  speackerDesription6:
    '张舒艺，纯白矩阵联合创始人兼CTO，前亚马逊工程师。张舒艺的擅长领域包括人工智能，区块链，大数据和分布式系统，并在这些领域发表了多篇顶级会议论文。张舒艺以优异的成绩获得了阿尔伯塔大学的计算机一等荣誉学士学位，并Michael Buro教授的指导下并获得了人工智能方向的硕士学位。毕业后，他加入了亚马逊，领导开发了亚马逊内部的全球会计对账平台，该项目使用区块链技术解决了PB级对账问题。目前，他是纯白矩阵的CTO，并领导核心开发团队，并领导开发了世界上流量最大的多链智能合约云端集成开发环境ChainIDE。',
  speackerDesription7:
    '蔡玮，香港中文大学（深圳）教授。蔡玮博士现为香港中文大学深圳理工学院计算机工程系助理教授，并担任人云系统实验室的主任，以及港中大（SZ）-纯白矩阵联合元宇宙实验室的主任。蔡玮分别于2008年，2011年和2016年，获得厦门大学的本科学位、首尔国立大学的硕士学位和不列颠哥伦比亚大学（UBC）的博士学位。在加入香港中文大学（深圳）之前，他是UBC无线网络和移动系统（WiNMoS）实验室的博士后研究员。他已经完成了对中国中央研究院（台湾），香港理工大学和日本国立信息学研究所的研究访问。蔡博士与他人合作发表了50余篇关于云计算，边缘计算，交互式多媒体和区块链系统领域的期刊和会议论文。同时，他是IEEE Transactions on Cloud Computing的副编辑。他曾获得2015年度中国政府杰出外国自费留学生奖，2011至2015年的UBC博士四年奖学金以及Brain Korea 21奖学金。他还获得了ACM BSCI2019最佳学生论文奖和CCF CBC2018，IEEE CloudCom2014，SmartComp2014和CloudComp2013最佳论文奖。',
  speackerDesription8:
    'Anup Basu教授拥有美国马里兰大学帕克分校计算机科学博士学位。在90年代初期，他首次提出foveation原理应用在影像，视频，立体声和图形通信中，并被广泛运用在目前的工业标准中。他开创了主动摄像校准方法，该方法可模拟人眼的工作方式，使其远优于同期其他任何校准方法。他发明了单摄像机全景立体音响，并将凹面foveation影像与立体音响相结合使得3D电视拥有更好的效果。他目前的研究包括用于医疗，消费和遥感应用的多维图像处理和可视化、教育和游戏中的多媒体应用以及高负载无线3D多媒体传输。自1999年以来，他一直担任阿尔伯特大学计算机科学系教授。他还担任以下职务：2003-2004年，加州大学河滨分校客座教授；1996年奥地利格拉茨技术大学客座教授； 1997-2000年，阿尔伯特大学惠普成像系统教学实验室主任；以及NSERC，iCORE和Castle Rock研究主席、美国神经病学协会院士。',
  speackerDesription9:
    '孙昕尧，博士候选人，阿尔伯塔大学多媒体研究中心遥感研究组技术主管，纯白矩阵公司研究顾问。孙昕尧于2017年和2015年获得艾伯塔大学计算机系的硕士研究生和学士学位。在博士学习之，拥有5年以上的工业领域开发背景，主要涉及全栈和移动应用的开发。他于2015年在硅谷TCL美国研究所实习，主要从事室内无人机自的人机交互项目。期间作为3个第一发明人，申请和获取了与计算机视觉，人体检测和面部验证相关的4项美国专利。他合伙创立的区块链初创公司Bi.Link＆Bi9.cn，提供了一个数字资产管理平台，并帮助客户在2018年获得了150万美元的利润。同时建立了托管在以太坊和EOS公链上的去中心化数字资产借贷和交易平台。他目前的博士研究方向是使用深度学习和信号处理技术来加速用于航空航天领域的卫星信号处理，以用于广域的地球表面位移的监控。他设计的DeepInSAR模型已被温哥华3vGeomoatic 公司投入生产环境使用，为全球客户提供服务。作为纯白矩阵研究顾问，帮助指导阿尔伯塔大学计算机系多媒体硕士研究生与纯白矩阵的合作研究项目，涉及计算共识区块链，智能合约自动化，去中心化金融系统和跨链安全性。',
  speackerDesription10:
    '王泽华博士在加拿大英属哥伦比亚大学UBC获得电子和计算机工程博士学位，并继续从事博士后研究。在2017年到2019年期间，他担任加拿大RightMesh的首席科学家。在任职期间，该公司受到加拿大总理贾斯汀·特鲁多（Justin Trudeau）的称赞。王泽华博士目前是加拿大不列颠哥伦比亚大学电子与计算机工程系的研究教授。 王泽华博士是第一位在UBC设计并开设了两门区块链课程的教授，包括区块链基础和区块链软件工程，并且目前指导数位硕士和博士生。他的研究领域包括保护隐私的机器学习，状态通道技术以及分散式身份验证和授权。',
  speackerDesription11:
    'Irene Cheng, SIEEE博士（在UofA获得博士学位并在宾夕法尼亚大学进行博士后研究）是加拿大阿尔伯塔大学多媒体研究中心的科学主任，并担任多媒体计划主任和科学学院的兼职教授。她是NSERC DG计算机科学评估组和AlbertaAI顾问委员会的成员。她曾担任IEEE SMC（2017）和ICME（2013）的技术计划主席，以及ICME（2011）的主席。她获得了IEEE SMC协会优异服务奖（2019）和IEEE通信协会MMTC杰出领导奖（2014）。她的其他专业职位包括：IEEE THMS的副编辑（2014-17），IEEE ICME指导委员会成员（2012-13、2016-18），IEEE SMC协会创始主席，视觉人类视觉，图形和多媒体技术委员会（ 2010年），IEEE NCS主席，EMBS分会（2009-11年）和MMTC 3D处理，渲染和通信兴趣小组（2010-12年），IEEE通信学会创会主席以及MMTC电子信函的领导者和R字母编辑委员会的委员（2012-14）。她曾是法国里昂（INSA）的客座教授（2011年），并获得了UofA校友地平线奖（2008年）。她还是劳埃德银行国际（Lloyds Bank International）的亚洲地区（现为劳埃德TSB，其总部位于英国）的IT，会计和行政主管。她的研究领域包括多媒体数据分析和感知质量评估。',
  speackerDesription12:
    '于隽在长江商学院获得工商管理硕士学位，在中国科技大学获得物理学学士学位。现任蚂蚁集团投资总监兼A&T资本管理合伙人。2013年至2017年，任人人公司战略发展部总监，复星集团高级投资总监，负责索菲、雪球金融、GoGoVan的投资。从2018年到2019年，他担任OKEx的投资总监和OK Capital的创始合伙人，领导对Ankr、Celer和Certik的投资。',
  speackerDesription13:
    'Aaron Liu于2011年从阿尔伯塔大学毕业。他曾在IBM、黑莓、EMC^2、Intuit和Electronic Arts等不同的IT行业公司工作。通过技术、云游戏和电子商务，深入各个领域。作为一名技术带头人，他指导不同级别的开发人员，从合作社学生到高级工程师。现在，他是BestBuy市场研发部的首席工程师。',
  speackerDate: '4月27日',
  speackerDate1: '4月30日',
  speackerDate2: '4月30日',
  speackerDate3: '4月29日',
  speackerDate4: '4月27日',
  speackerDate5: '4月27日',
  speackerDate6: '4月27日',
  speackerDate7: '4月30日',
  speackerDate8: '4月28日',
  speackerDate9: '4月29日',
  speackerDate10: '4月28日',
  speackerDate11: '4月27日',
  speackerDate12: '4月30日',
  speackerDate13: '4月30日',
  speackerSubject: '开幕致辞',
  speackerSubject1: '圆桌会议成员',
  speackerSubject2: '圆桌会议成员',
  speackerSubject3: '数据科学主题演讲',
  speackerSubject4: '区块链主题演讲',
  speackerSubject5: '浅析数据科学',
  speackerSubject6: '浅析区块链',
  speackerSubject7: '区块链和多媒体数据科学应用I',
  speackerSubject8: 'AI：计算机视觉与机器学习',
  speackerSubject9: '区块链和多媒体数据科学应用II',
  speackerSubject10: '区块链赋能隐私计算',
  speackerSubject11: '主持人',
  speackerSubject12: '圆桌会议成员',
  speackerSubject13: '圆桌会议成员',
  speackerName: 'Matina Kalcounis Rueppell博士',
  speackerName1: 'Carlos Garcia',
  speackerName2: 'Neha Raj',
  speackerName3: 'Bruce Matichuk博士',
  speackerName4: '吴啸',
  speackerName5: 'Marcin Mizianty博士',
  speackerName6: '张舒艺',
  speackerName7: '蔡玮',
  speackerName8: 'Anup Basu博士',
  speackerName9: '孙昕尧',
  speackerName10: '王泽华教授',
  speackerName11: 'Irene Cheng博士',
  speackerName12: '于隽',
  speackerName13: 'Aaron Liu'
};
export default zh;
